import { Field } from '../../../models/field.model'
import {
  FilterCollection,
  FilterOperator,
  FilterType,
} from '../../../models/filter.model'
import { SupplierOrderField } from '../models/supplier-order-search.model'
import { SupplierOrderViewType } from '../models/supplier-order.types'

export const SUPPLIER_ORDER_FIELDS: Field<
  SupplierOrderField,
  SupplierOrderViewType
>[] = [
  {
    label: '# ordine',
    field: 'header.orderNumber',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.between,
      FilterOperator.lessThan,
      FilterOperator.lessOrEqualThan,
      FilterOperator.moreThan,
      FilterOperator.moreOrEqualThan,
    ],
    filterType: FilterType.number,
  },
  {
    label: 'Data/Ora creazione',
    field: 'createdAt',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.between,
      FilterOperator.beforeThan,
      FilterOperator.beforeOrEqualThan,
      FilterOperator.afterThan,
      FilterOperator.afterOrEqualThan,
    ],
    filterType: FilterType.date,
  },
  {
    label: 'Data consegna prevista',
    field: 'header.deliveryDate',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.between,
      FilterOperator.beforeThan,
      FilterOperator.beforeOrEqualThan,
      FilterOperator.afterThan,
      FilterOperator.afterOrEqualThan,
    ],
    filterType: FilterType.date,
  },
  {
    label: 'Magazzino',
    field: 'warehouseId',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.warehouses,
  },
  {
    label: 'Rif. ordine',
    field: 'header.rifOrder',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.text,
  },
  {
    label: 'Rif. data',
    field: 'header.rifDate',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.between,
      FilterOperator.beforeThan,
      FilterOperator.beforeOrEqualThan,
      FilterOperator.afterThan,
      FilterOperator.afterOrEqualThan,
    ],
    filterType: FilterType.date,
  },
  {
    label: 'Fornitore',
    field: 'supplierId',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.suppliers,
  },
  {
    label: 'Subtotale i.e.',
    field: 'header.subTotal',
  },
  {
    label: 'Totale',
    field: 'header.totalOrderAmount',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Stato',
    field: 'status',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Righe',
    field: 'rowsCount',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Pezzi',
    field: 'productsCount',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
  },
  {
    label: '% Ord./Ric.',
    field: 'completion',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Note',
    field: 'header.notes',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Parziale',
    field: 'isPartial',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Allegati',
    field: 'attachments',
    defaultViews: ['SUPPLIER_ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Esportato',
    field: 'isExported',
  },
]
